<template>
  <w-icon-wrapper icon-name='work-minus-icon'>
    <g
      id='_15_Löschen_Icon'
      data-name='15 Löschen_Icon'
      transform='translate(0.25)'
    >
      <path
        id='Pfad_55665'
        d='M11.75,0a12,12,0,1,0,12,12A12,12,0,0,0,11.75,0Zm0,22a10,10,0,1,1,10-10A10.011,10.011,0,0,1,11.75,22Z'
        data-name='Pfad 55665'
        fill='currentColor'
      />
      <path
        id='Pfad_55666'
        d='M16.25,11h-9a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z'
        data-name='Pfad 55666'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconMinus' };
</script>
